<script setup>
import {computed} from "vue";
import TextField from "../../Registration/components/Fields/TextField.vue";
import FallbackField from "../../Registration/components/Fields/FallbackField.vue";
import SelectField from "../../Registration/components/Fields/SelectField.vue";
import TextBlockField from "../../Registration/components/Fields/TextBlockField.vue";
import TextareaField from "../../Registration/components/Fields/TextareaField.vue";
import NumberField from "../../Registration/components/Fields/NumberField.vue";
import DateField from "../../Registration/components/Fields/DateField.vue";
import CheckBoxField from "../../Registration/components/Fields/CheckBoxField.vue";
import SpacerField from "../../Registration/components/Fields/SpacerField.vue";
import RadioButtonField from "../../Registration/components/Fields/RadioButtonField.vue";
import CheckboxMultiselectField from "../../Registration/components/Fields/CheckboxMultiselectField.vue";
import {useVisibilityRules} from "../../Registration/composables/useVisibilityRules";
import {useBookingStore} from "../../Registration/stores/bookingStore";
import FileUploadField from "../../Registration/components/Fields/FileUploadField.vue";

const emit = defineEmits(['blur', 'input']);

const {item, group = null, groupId = null, backend = null, formData = null} = defineProps(['item', 'group', 'groupId', 'backend', 'formData']);

const componentMap = {
    'text': TextField,
    'select': SelectField,
    'number': NumberField,
    'decimal': NumberField,
    'textarea': TextareaField,
    'text-block': TextBlockField,
    'date': DateField,
    'checkbox': CheckBoxField,
    'spacer': SpacerField,
    'radio': RadioButtonField,
    'checkbox_multiple': CheckboxMultiselectField,
    'file-upload': FileUploadField
}

const RenderComponent = computed(() => componentMap[item.render_type] || FallbackField);

const store = formData ? null : useBookingStore();
const {evaluateVisibilityRules} = useVisibilityRules(formData);

const isVisible = computed(() => {
    let companionIndex = null;

    // Only handle companions for registration flow (when store exists)
    // For checkout flow, companions are handled in a separate component
    if (store && group === 'companions' && groupId) {
        companionIndex = store.data.companions.findIndex(c => c.uniqueId === groupId);
        companionIndex = companionIndex >= 0 ? companionIndex : null;
    }

    return evaluateVisibilityRules(item.visibility_rules, companionIndex);
});

const classes = computed(() => {
    const baseClasses = ['form-item-wrapper', item.width];

    if (!isVisible.value) {
        baseClasses.push('hidden');
    }

    baseClasses.push(`type-${item.render_type}`);

    return baseClasses.join(' ');
});

const getId = () => {
    let id = `form-item`;
    if (group !== null) {
        id += `-${group}`;
    }
    if (groupId !== null) {
        id += `-${groupId}`;
    }
    return `${id}-${item.id}`;
}
</script>

<template>
    <div :class="classes" :id="getId()">
        <component
            :is="RenderComponent"
            :item="item"
            :group="group"
            :groupId="groupId"
            :backend="backend"
            @blur="emit('blur', $event)"
            @input="emit('input', $event)"
        />
    </div>
</template>

<style scoped>

</style>
